{{#unless isHidden}}
{{#if subs}}
	<a id="{{this.entry_id}}" class="sidebar-text-color {{#if active}}subdrop{{/if}}" href="javascript:void(0);">
		{{#if icon}}<i class="{{icon}}"></i>{{/if}}
		<span>{{text}}</span>
		<span class="menu-arrow sidebar-text-color"></span>
	</a>
	<ul class="list-unstyled" {{#if this.active}}style="display: block;"{{/if}}>
	{{#each subs}}
		<li class="has_sub {{#if this.active}}active{{/if}}">
			<a id="{{this.entry_id}}" class="sidebar-text-color" href="{{this.url}}"><span>{{this.text}}</span></a>
			{{#if this.subs}}
			<ul>
				{{#each this.subs}}
					<li {{#if this.active}}class="active"{{/if}}>
						<a href="{{this.url}}" class="sidebar-text-color">{{this.text}}</a>
					</li>
				{{/each}}
			</ul>
			{{/if}}
		</li>
	{{/each}}
	</ul>
{{else}}
	{{#if url}}
		<a id="{{this.entry_id}}" class="sidebar-text-color {{#if active}}subdrop{{/if}}" href="{{url}}">
			{{#if icon}}<i class="{{icon}}"></i>{{/if}}
			<span>{{text}}</span>
		</a>
	{{else}}
		<span class="sidebar-text-color">{{text}}</span>
	{{/if}}
{{/if}}
{{/unless}}
